import {get} from 'lodash-es';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';

import {IFieldMeta} from 'entities/metadata';
import {openModal} from 'store/slices/modals-slice';

interface IOpenModalActionProps {
    url: string;
    entityName: string;
    record: any;
    field: IFieldMeta;
}

export const OpenModalAction: FC<IOpenModalActionProps> = ({
    url,
    entityName,
    record,
    field,
}: IOpenModalActionProps) => {
    const dispatch = useDispatch();
    const dependentsFieldKey = record?.[field?.dependentsFieldKey || ''];
    const handlerClick = () => {
        if (field.modalName) {
            dispatch(openModal({
                modalName: field.modalName,
                entityName,
                modalParameters: {
                    filterSystemComponent: record[field.key],
                    key: field.key,
                    referenceUrl: field.referenceUrl,
                },
            }));
        }
    };

    return (
        <>
            {
                dependentsFieldKey
                    ? (
                        <Link
                            to={`${url}`}
                            onClick={handlerClick}
                        >
                            {get(record, field.key)}
                        </Link>
                    )
                    : (
                        <>
                            {get(record, field.key)}
                        </>
                    )
            }
        </>
    );
};
